
import React from 'react';
import {Modal2} from "../modal";
import {TextLoading} from "../../funcs/utils";
import {adminAddAccount} from "./actions";
import {sprintf} from "sprintf-js";
import {AccountState} from "../../../lib/constants";
import { ACCOUNT_NUMBER, ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE } from "./prm";
import { poll_tda_item } from "./tda_utils";
import {onboarding_start_segment} from "../../../lib/onboarding-utils";

const remove_blanks = str => {
  const re = /^\s*(\S+)\s*$/;
  const match = str.match(re);
  if (!match) {
    return str;
  }
  return match[1];
}

const add_account = (
  component, username, identity_id, index, wlf_id, name, confirmed) => () => {

  component.setState({
    dialog_exec: true,
  });

  const tda_account_number = ACCOUNT_NUMBER.isBlank(component.state)
    ? null : remove_blanks(ACCOUNT_NUMBER.getValue(component.state));
  const envelope_id = ENVELOPE_ID.isBlank(component.state)
    ? null : remove_blanks(ENVELOPE_ID.getValue(component.state));
  const signing_type = ELECTRONIC_SIGNING_TYPE.getValue(component.state).id;

  const token = component.props.token;
  let tda_item;

  adminAddAccount(
    component.props.token, username, tda_account_number, signing_type, envelope_id)
    .then(onboarding_items => {
      return poll_tda_item(token, onboarding_items, username, identity_id, index, wlf_id, confirmed)
        .then(onboarding_items => {
          tda_item = onboarding_items.tda;
          component.setState({
            show_add_account_dialog: null,
            dialog_exec: false,
          });
          // Add the new items to the data stores
          component.props.setOnboardingData(
            onboarding_items.onboarding, index, username);
          component.props.tdaUpdate(onboarding_items.tda, index, username);
          component.props.dwollaUpdate(onboarding_items.dwolla, index, username);

          return component.maybeLoad(true);
        })
        .then(() => {

          return component.load_user_items(username);

        })
        .then(() => {
          const segment = onboarding_start_segment(component.props.app.wlf);
          const url = sprintf("/super-admin/onboarding_%04d/%s", index, segment);
          const args = {
            username,
            acct_index: index,
            identity_id,
            account_state: AccountState.ONBOARDING_PROXY,
            tda_account_number: tda_item.tda_account_number,
            name,
          }
          component.props.navigatePath(url, args);
        })
    });
}

const on_prm_change = (component, new_state, prm) => {
  const type_value = ELECTRONIC_SIGNING_TYPE.getValue(new_state).id;
  ENVELOPE_ID.setDisabled(new_state, type_value !== "signed");
}

const render_missing_props = (props, name) => {
  const props_str = props.join(", ");
  return (
    <div>
      <div style={{fontSize: "1.2rem"}}>{name} onboarding for account 0000 is missing props.</div>
      <div style={{height: "2rem"}}/>
      <div>{props_str}</div>
    </div>
  )
}
const AddUserAccountModal = props => {

  const { component, name, username, identity_id, index, wlf_id, confirmed, missing_props }
    = props;

  const container_style = {
    width: "30rem",
  }
  const on_close = () => {
    component.setState({
      show_add_account_dialog: null,
    })
  }
  const loading = component.state.dialog_exec;

  const button_list = [
    {
      label: "Cancel",
      cb: on_close,
    },
    {
      label: (
        <TextLoading
          loading={loading}
          label={"Add Account"}/>
      ),
      cb: add_account(component, username, identity_id, index, wlf_id, name, confirmed),
    }
  ];

  const missing_buttons = [
    {
      label: "Ok",
      cb: on_close,
    }
  ];
  const header_style = {
    padding: "0.5rem",
  }
  const header = "Add Account";
  const div_style = {
    marginBottom: "1rem",
  }

  let body = missing_props.length > 0
    ? render_missing_props(missing_props, name)
    : (<div>
        <div style={div_style}>Add new account for {name}?</div>
        <div>Account Number (Can be blank)</div>
        <div style={div_style}>{ACCOUNT_NUMBER.renderInput(component)}</div>
        <div>Envelope Type</div>
        <div style={div_style}>{ELECTRONIC_SIGNING_TYPE.renderMenu(component)}</div>
        <div>Docusign Envelope Id:</div>
        <div>{ENVELOPE_ID.renderInput(component)}</div>
      </div>);

  return (
    <Modal2
      container_style={container_style}
      header_style={header_style}
      header={header}
      buttonList={missing_props.length > 0 ? missing_buttons : button_list}>
      { body }
    </Modal2>
  )
}

export { AddUserAccountModal, on_prm_change };
